import { render, staticRenderFns } from "./MultipleGhostCardsSelectBox.vue?vue&type=template&id=71bb8dd1&scoped=true&"
import script from "./MultipleGhostCardsSelectBox.vue?vue&type=script&lang=js&"
export * from "./MultipleGhostCardsSelectBox.vue?vue&type=script&lang=js&"
import style0 from "./MultipleGhostCardsSelectBox.vue?vue&type=style&index=0&id=71bb8dd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bb8dd1",
  null
  
)

export default component.exports